import {DiscountResponse} from "@/types/service-response";

export default class Discount {
  private constructor(
      readonly activeFrom: string,
      readonly activeUntil: string,
      readonly calculationMethod: any,
      readonly createdAt: string,
      readonly discountTargets: any[],
      readonly id: string,
      readonly scope:any,
      readonly targetBoarders: string[],
      readonly tenant: string,
      readonly title: string,
      readonly value: string,
      readonly valueKind: any
  ) {}


  static createFromResponse(responseData: DiscountResponse): Discount {

    return new Discount(
        responseData.activeFrom,
        responseData.activeUntil,
        responseData.calculationMethod,
        responseData.createdAt,
        responseData.discountTargets,
        responseData.id,
        responseData.scope,
        responseData.targetBoarders,
        responseData.tenant,
        responseData.title,
        responseData.value,
        responseData.valueKind,
    )
  }

  static createFromResponseList(responseData: DiscountResponse[]): Discount[] {
    return responseData.map((item:DiscountResponse) => {
      return new Discount(
          item.activeFrom,
          item.activeUntil,
          item.calculationMethod,
          item.createdAt,
          item.discountTargets,
          item.id,
          item.scope,
          item.targetBoarders,
          item.tenant,
          item.title,
          item.value,
          item.valueKind,
      )
    })
  }
}